'use strict';/* global define */define('modules/time/services/calendar-events/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$resource", "$cookies", "Cancelator", "API_ENDPOINT", "_"];
function factory($resource,$cookies,Cancelator,API_ENDPOINT,_){// jshint validthis:true
// jshint latedef:false
var baseUrl=API_ENDPOINT+'calendar-events/:id';var baseUrlUsers=API_ENDPOINT+'users/:id/calendar-events';var baseUrlFeedbackProcesses=API_ENDPOINT+'feedback-processes/:id/calendar-events';var CalendarEvents=$resource(baseUrl,{id:'@id'},{patch:{method:'PATCH'}});var CalendarEventFeedbackProcesses=$resource(baseUrlFeedbackProcesses,{id:'@id'});return{getAll:getAll,get:CalendarEvents.get,update:CalendarEvents.patch,create:CalendarEvents.save,getAllForUser:getAllForUser,getAllForFeedbackProcess:getAllForFeedbackProcess,getEventLink:getEventLink};// ---
/**
     * Get all calendar events
     *
     * @param  {Object} params - Query parameters - id and format
     * @return {Object}        - Return promise object
     */function getAll(params){return CalendarEvents.get(params);}/**
     * Get all calendar events for selected user
     *
     * @param  {Object} params - Query parameters
     * @return {Object}        - Return promise object
     */function getAllForUser(params){var resource=Cancelator.createResource(baseUrlUsers,{id:'@id'},{get:{method:'GET'}});return resource.get(params);}/**
     * Get all calendar events for selected feedback process
     *
     * @param  {Object} params - Query parameters
     * @return {Object}        - Return promise object
     */function getAllForFeedbackProcess(params){return CalendarEventFeedbackProcesses.get(params);}/**
     * Helper method to construct the calendar event download link
     *
     * @param  {String} id - Calendar event id
     *
     * @return {String}    - Calendar event link
     */function getEventLink(id){var accessToken=$cookies.getObject('access-token');var clientId=$cookies.getObject('client-id');return API_ENDPOINT+'calendar-events/'+id+'.ics?loopline_client='+clientId+'&access_token='+accessToken;}}module.exports=factory;});
